module.exports = __webpack_public_path__ + "static/img/78095E_2_R_20190901_LC.feda9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78095E_2_R_20190901_LC.png
// module id = CjwY
// module chunks = 0